import { useState } from 'react'

import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../constants/request'
import {
  useRequestConnectDocFlowsModalOpener,
  useRequestCreateDocFlow,
  useRequestDisconnectDocFlows,
} from '../../../Request'
import { useRequestProfileContext } from '../useRequestProfileContext'

export function useRequestProfileDocFlowLinkActions() {
  const { handleCloseModal, handleReloadAfterChange, requestData, setModal } =
    useRequestProfileContext()

  const requestId = requestData?.id

  const [isPerformingAction, setPerformingAction] = useState(false)

  async function handleReloadAfterSuccess() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.docFlows)
  }

  const { handleOpenDocFlowCreation } = useRequestCreateDocFlow({
    onCloseModal: handleCloseModal,
    onReload: handleReloadAfterSuccess,
    onSetModal: setModal,
  })

  const { handleOpenConnectDocFlows } = useRequestConnectDocFlowsModalOpener({
    onCloseModal: handleCloseModal,
    onReload: handleReloadAfterSuccess,
    onSetModal: setModal,
  })

  const { handleOpenDisconnectDocFlows } = useRequestDisconnectDocFlows({
    onCloseModal: handleCloseModal,
    onSetModal: setModal,
  })

  function handleClickCreateDocFlow() {
    handleOpenDocFlowCreation([requestData])
  }

  function handleClickConnectDocFlow() {
    handleOpenConnectDocFlows(requestId)
  }

  function handleDisconnectStart() {
    setPerformingAction(true)
  }

  function handleDisconnectSettled() {
    setPerformingAction(false)
  }

  function handleClickDisconnectDocFlows({ docFlowIds, onSuccess }) {
    function handleDisconnectSuccess() {
      onSuccess()

      handleReloadAfterSuccess()
    }

    handleOpenDisconnectDocFlows({
      docFlowIds,
      requestId,
      onSettled: handleDisconnectSettled,
      onStart: handleDisconnectStart,
      onSuccess: handleDisconnectSuccess,
    })
  }

  return {
    handleClickConnectDocFlow,
    handleClickCreateDocFlow,
    handleClickDisconnectDocFlows,
    isPerformingAction,
  }
}
